export class Extend {
    first_name: string;
    last_name: string;
    qualification: string;
    institution: string;
    yearq: number;
    expertise: string;
    degree: string;
    designation: string;
    grad_year: string;
    org_code: string;
    email: string;
    dob: string;
    add_1: string;
    add_2: string;
    city_n: string;
    state: string;
    zip: number;
    contact_n: number;
    altemail: string;
    u_type: number;
}
